import { ActionReducerMap } from '@ngrx/store';

import * as identityStore from '@core/identity/store';

export const coreFeatureName = 'core';

export interface CoreState {
  [identityStore.identityStateKey]: identityStore.IdentityState;
}

export const coreReducers: ActionReducerMap<CoreState> = {
  [identityStore.identityStateKey]: identityStore.identityReducer,
};
